import type {RoadmapTab} from './types';

export interface RoadmapTabDefinition {
  id: RoadmapTab;
  label: string;
}

const PEOPLE_ROADMAP_TAB: RoadmapTabDefinition = {id: 'all', label: 'All'};

const ROADMAP_TABS: RoadmapTabDefinition[] = [
  {id: 'launches', label: 'Launches'},
  {id: 'roadmap', label: 'Roadmap'},
  {id: 'dependencies', label: 'Dependencies'},
  {id: 'rollup', label: 'Rollup'},
  {id: 'allocations', label: 'Allocations'},
  {id: 'audit', label: 'Audit'},
];

export const getRoadmapTabDefinitions = (isPeopleScope = false): RoadmapTabDefinition[] =>
  isPeopleScope ? [PEOPLE_ROADMAP_TAB, ...ROADMAP_TABS] : ROADMAP_TABS;
